// extracted by mini-css-extract-plugin
export default {"banner":"DemoModeBanner_banner__KB+en","icon":"DemoModeBanner_icon__a2TST","title":"DemoModeBanner_title__kRY8s","message":"DemoModeBanner_message__n+gwC"};